/* eslint-disable george/no-absolute-alias-for-packages */
import { featureConfigMap as watchdogs } from '@retail/watchdogs-utils';
import {
    addressBookFeatureConfigMap,
    ownFxTransferFeatureConfigMap,
    ownTransferFeatureConfigMap,
    paymentOrdersFeatureConfigMap,
    paymentsFeatureConfigMap,
    sepaDirectDebitFeatureConfigMap,
    standingOrdersFeatureConfigMap,
} from '@retail/payments-config';
import { featureConfigMap as signing } from '@george/shared/signing/src/lib/featureConfig/featureConfigMap';
import { featureConfigMap as insurances } from '@retail/insurance-config';
import { featureConfigMap as leasings } from '@retail/leasing-config';
import { featureConfigMap as loans } from '@retail/loan-config';
import { featureConfigMap as pension } from '@retail/pension-config';
import { featureConfigMap as investments } from '@retail/investments-config';
import { initFeatureConfig, registerFeatureConfigMap } from '@luna/feature-config';

// @ts-expect-error no-implicit-any
export const initRetailFeatureConfig = (countryFeatureConfigMap): void => {
    initFeatureConfig();
    registerFeatureConfigMap(countryFeatureConfigMap);
    registerFeatureConfigMap(addressBookFeatureConfigMap, 'addressBook');
    registerFeatureConfigMap(ownTransferFeatureConfigMap, 'ownTransfer');
    registerFeatureConfigMap(ownFxTransferFeatureConfigMap, 'ownFxTransfer');
    registerFeatureConfigMap(paymentOrdersFeatureConfigMap, 'paymentOrders');
    registerFeatureConfigMap(paymentsFeatureConfigMap, 'payments');
    registerFeatureConfigMap(sepaDirectDebitFeatureConfigMap, 'sepaDirectDebit');
    registerFeatureConfigMap(standingOrdersFeatureConfigMap, 'standingOrders');
    registerFeatureConfigMap(signing, 'signing');
    registerFeatureConfigMap(insurances, 'insurances');
    registerFeatureConfigMap(leasings, 'leasings');
    registerFeatureConfigMap(loans, 'loans');
    registerFeatureConfigMap(pension, 'pension');
    registerFeatureConfigMap(investments, 'investments');
    registerFeatureConfigMap(watchdogs, 'watchdogs');
};
